export class InformationMessages {
  public filename = 'information.filename';
  public filenameOriginal = 'information.filename_original';
  public title = 'information.title';
  public validationResult = 'information.validation_result';
  public sizeSignature = 'information.sizeSignature';
  public sizeHorodatage = 'information.sizeHorodatage';

  constructor() {
  }
}
